import { GalleryVerticalEnd } from "lucide-react";
import React, { useEffect, useState } from "react";

import { cn } from "@/lib/utils";
import { Button } from "@/styles/ui/button";
import { useSidebar } from "@/styles/ui/sidebar";

export const SidebarWorkspaceTrigger = React.forwardRef<
  React.ElementRef<typeof Button>,
  React.ComponentProps<typeof Button>
>(({ className, onClick, ...props }, ref) => {
  const { toggleSidebar } = useSidebar();

  return (
    <Button
      ref={ref}
      data-sidebar="trigger"
      variant="ghost"
      size="icon"
      className={cn(
        "h-8 w-8 bg-[#171717] rounded-lg [&_svg]:text-white",
        className,
      )}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onClick?.(event);
        toggleSidebar();
      }}
      {...props}
    >
      <GalleryVerticalEnd className="h-8 w-8" />
      <span className="sr-only">Toggle Sidebar</span>
    </Button>
  );
});

export const Overlay = () => {
  const { state, isMobile, setOpen } = useSidebar();
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  const shouldShow = !isMobile && state !== "collapsed";

  useEffect(() => {
    if (shouldShow) {
      setShouldRender(true);
      requestAnimationFrame(() => {
        setIsVisible(true);
      });
    } else if (isVisible) {
      setIsVisible(false);
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [shouldShow, isVisible]);

  if (!shouldRender) {
    return null;
  }

  return (
    <div
      data-sidebar-overlay
      className={cn(
        "fixed inset-0 z-40 bg-black/50 transition-opacity duration-500",
        isVisible ? "opacity-100" : "opacity-0 pointer-events-none",
      )}
      onClick={() => setOpen(false)}
    />
  );
};
